// extracted by mini-css-extract-plugin
export default {"buttonCta":"CardButton_buttonCta__FOX4v"};